export class ShaderDefine {
    constructor(index, value) {
        this._index = index;
        this._value = value;
    }
}
